import { useSetAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { pogDeleteProductDataAtom } from "./atoms";
import { ResponseMerchFlowApplyFilters } from "@CommonApi/merchandise";
import { PlanogramItem, UnrangedPlanogramItem } from "@CommonTypes/merchflow/pog/item";

export const usePogDeleteProductModal = () => {
  const { openModal } = useModals();
  const setData = useSetAtom(pogDeleteProductDataAtom);

  const openPogDeleteProductModal = ({
    item,
    availableStores,
  }: {
    item: PlanogramItem | UnrangedPlanogramItem;
    availableStores: ResponseMerchFlowApplyFilters["filter_config"];
  }) => {
    setData({ item, availableStores });
    openModal("ModalPogDeleteProduct");
  };

  return { openPogDeleteProductModal };
};
